import * as React from "react"
const ShapeShoulderIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    shapeRendering="geometricPrecision"
    textRendering="geometricPrecision"
    viewBox="0 0 300 300"
    {...props}
  >
    <path
      fill="#f39752"
      d="m163.663 119.63 21.074-41.355 20.678-7.157 8.35 14.315 26.244 95.433 23.46 74.756 14.316 20.28-6.76 9.94-14.315-1.988q-27.437-12.724-27.835-12.724t-30.22-24.654l-16.701-38.173-13.122-46.524-5.17-42.15Z"
    />
    <path
      fill="none"
      stroke="#ed1f1f"
      strokeLinecap="round"
      strokeWidth={6}
      d="M155.988 123.95c1.837 11.145 3.887 22.86 6.546 34.238 9.94 42.548 32.648 61.983 61.278 61.983"
      transform="matrix(1.69364 0 0 1.69364 -101.272 -87.049)"
    />
    <path
      fill="none"
      stroke="#717171"
      strokeLinecap="round"
      strokeWidth={6}
      d="M67.037 223.015q29.462-19.894 38.21-64.827c8.748-44.933 14.584-94.625 30.183-94.625 11.63 0 15.178 27.744 20.558 60.387"
      transform="matrix(1.69364 0 0 1.69364 -101.272 -87.049)"
    />
    <path
      fill="none"
      stroke="#717171"
      strokeLinecap="round"
      strokeWidth={6}
      d="M116.282 120.978c5.93-5.96 6.104-33.104 20.66-33.104s26.296 97.2 46.722 125.608"
      transform="matrix(1.69364 0 0 1.69364 -33.276 -77.708)"
    />
  </svg>
)
export default ShapeShoulderIcon
